// Support / "Soporte" contact configuration.
//
// These are the direct, verified contact routes shown on the Support tab.
// Kept in one place so contacts are easy to audit and update without touching
// the page component.
//
// EMAIL: both addresses are copied on every "report a problem" email. They are
// verified team contacts. The Support page composes a mailto: link that opens
// in the user's own email client — nothing is sent automatically and there is
// no ticketing backend.
export const SUPPORT_EMAILS = [
  'roger@qomplement.com',
  'fernanda@qomplement.com',
];

// WHATSAPP: the verified business support WhatsApp number (E.164). This is the
// team support line shown on the Support page. buildWhatsAppUrl() below validates
// it; an invalid/unset value keeps the WhatsApp option hidden so we never ship a
// guessed number or a dead button in a customer-facing flow.
const WHATSAPP_E164 = '+16282685093';

// Strict E.164 check: leading '+', 8..15 digits, first digit non-zero.
const E164_RE = /^\+[1-9]\d{7,14}$/;

export const isValidE164 = (value) =>
  typeof value === 'string' && E164_RE.test(value.trim());

// Returns the verified WhatsApp number (E.164) or null when unset/invalid.
// A null return means the WhatsApp option must not render.
export const getSupportWhatsApp = () =>
  isValidE164(WHATSAPP_E164) ? WHATSAPP_E164.trim() : null;

// Build a wa.me deep link from a verified E.164 number (digits only, no '+').
// Returns null for any invalid/unset number so callers never render a dead link.
export const buildWhatsAppUrl = (e164, text) => {
  if (!isValidE164(e164)) return null;
  const digits = e164.trim().replace(/^\+/, '');
  const base = `https://wa.me/${digits}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};
